// Navigation toggle functionality
// const btn = document.querySelector('.js-menu-btn');
// btn.addEventListener('click', () => {
//     btn.classList.toggle('is-active');
//     document.documentElement.classList.toggle('has-open-nav');
// });

// // Handle resize events
// function handleResize() {
//     if (window.matchMedia('(min-width: 992px)').matches) {
//         btn.classList.remove('is-active');
//         document.documentElement.classList.remove('has-open-nav');
//     }
// }

// window.addEventListener('resize', handleResize);

// Site select toggle
const siteSelect = document.querySelector('.js-site-select');
siteSelect?.addEventListener('click', () => {
    siteSelect.classList.toggle('is-active');
});

// Grid/List view toggle
document.querySelectorAll('.js-view-toggle').forEach((button) => {
    button.addEventListener('click', () => {
        if (button.classList.contains('is-active')) return;
        document.cookie = `gridlist=${button.dataset.view}; path=/; max-age=31536000; samesite=lax`;
        window.location.reload();
    });
});
